export default __webpack_public_path__ + "static/media/logo-white.66be08a0.jpeg";